var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "croxxmobile 1",
    clipPath: "url(#clip0_12219_40028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2101 5.75V7.25L1.81006 13.74V5.75C1.81006 2.15 2.71006 1.25 6.31006 1.25H11.7101C15.3101 1.25 16.2101 2.15 16.2101 5.75Z",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.81 4.40039H7.20996",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.01012 16.6398C9.78012 16.6398 10.4101 16.0198 10.4101 15.2398C10.4101 14.4598 9.79012 13.8398 9.01012 13.8398C8.23012 13.8398 7.62012 14.4598 7.62012 15.2398C7.62012 16.0198 8.24012 16.6398 9.01012 16.6398Z",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.37 6.73047L16.21 7.25047L1.81 13.7405L0.75 14.2205",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1.90984 16.0505C1.90984 16.0505 1.30984 19.6105 5.08984 19.6105H13.0098C13.0098 19.6105 16.2698 19.7905 16.2698 15.6005V9.73047",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12219_40028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.12,
    height: 19.86,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.e4978c5d6198ecb2cd39c76b14d5af16.svg";
export { ForwardRef as ReactComponent };